import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const ErrorRunPayrollModal = ({ errorMessage, handleClose, isModalOpen }) => {
  const navigate = useNavigate()
  return (
    <>
      <AdxInfoModal
        open={isModalOpen}
        onClose={handleClose}
        handleClose={handleClose}
        muiIcon="error"
        iconColor="warning.main"
        title="Error!"
        subtitle={errorMessage}
        footerButtons
        firstBtnLabel={'Head to Staff Management'}
        firstBtnHandle={() => navigate(`/app/management-centre/staff-management/employee-file`)}
        secondBtnLabel={'Close'}
        secondBtnHandle={handleClose}
      >
        {/* <AdxButton
          fullWidth
          onClick={() => navigate(`/app/management-centre/staff-management/employee-file`)}
        >
          Head to Staff Management
        </AdxButton>
        <AdxButton variant={'ghost'} fullWidth onClick={handleClose}>
          Close
        </AdxButton> */}
      </AdxInfoModal>
    </>
  )
}

export default ErrorRunPayrollModal
